import GlobalLoader from '@components/loader/global-loader';
import { initCart, setInitCart } from '@stores/cart';
import { popupSelector, resetPopup } from '@stores/popup';
import { ICart } from 'interfaces/cart';
import { DateTime } from 'luxon';
import { signOut } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

type TInitialSettingProps = {
  children?: React.ReactNode;
  error?: Record<string, any>;
};

export default function InitialSetting({
  children,
  error,
}: TInitialSettingProps) {
  const dispatch = useDispatch();
  const popups = useSelector(popupSelector);
  const router = useRouter();
  const inspection = false;

  const checkCartValidation = () => {
    const cartItem = localStorage.getItem('cart');
    if (cartItem) {
      try {
        const parsedCartItem: ICart & { updatedAt: string } = JSON.parse(
          cartItem || '',
        );
        if (parsedCartItem) {
          if (parsedCartItem.updatedAt) {
            const updatedAtDate = DateTime.fromISO(
              parsedCartItem.updatedAt,
            ).startOf('day');
            const today = DateTime.local().startOf('day');
            if (updatedAtDate < today) {
              localStorage.removeItem('cart');
              return;
            }
          }

          const isPriceValidation = parsedCartItem.menus.every(
            (menu) =>
              typeof menu.originalPrice === 'number' &&
              typeof menu.finalPrice === 'number',
          );

          if (!isPriceValidation) {
            dispatch(initCart({}));
            localStorage.removeItem('cart');

            return;
          }
          dispatch(setInitCart(parsedCartItem));
        }
      } catch (e) {
        console.error(e);
        dispatch(initCart({}));

        localStorage.removeItem('cart');
      }
    }
  };

  const initForce = async () => {
    const forceInit = router.query.forceInit;
    if (forceInit) {
      localStorage.removeItem('cart');
      localStorage.removeItem('tempAddress');
      dispatch(initCart({}));
      const result = await signOut({ callbackUrl: window.location.origin });
    }
  };

  useEffect(() => {
    checkCartValidation();
  }, []);

  useEffect(() => {
    const recommender = router.query.recommender;
    if (recommender) {
      localStorage.setItem('recommender', recommender as string);
    }
  }, [router.query]);

  useEffect(() => {
    initForce();
  }, [router.query]);

  useEffect(() => {
    const handlePopupState = () => {
      if (popups.length === 0) return;
      const filtered = popups.filter((_popup) => {
        if (_popup.isBackClose) return false;
        return !!_popup.id || !!_popup.queryId;
      });
      dispatch(resetPopup(filtered));
    };
    window.addEventListener('popstate', handlePopupState);

    return () => {
      window.removeEventListener('popstate', handlePopupState);
    };
  }, [popups]);

  return (
    <>
      {inspection ? (
        <div>
          <div className="min-h-screen flex items-center justify-center flex-col gap-2">
            <p className="font-bold text-lg">ประกาศด่วนจาก Food Panther</p>
            <div className="text-center flex flex-col gap-1">
              <p>วันที่ 30 กันยายน 2025 ขณะนี้เกิดปัญหาขึ้น 2 อย่างค่ะ</p>

              <p>
                1. ปัญหาที่เซิร์ฟเวอร์ของแพลตฟอร์มส่งอาหาร :
                ไม่สามารถทำรายการสั่งซื้อได้ตามปกติ
              </p>
              <p>
                2. ปัญหาที่เซิร์ฟเวอร์ของผู้ดูแลไลน์ :
                ไม่สามารถเห็นข้อความสนทนาของผู้ใช้งานได้
              </p>
              <p>
                คาดว่าจะใช้เวลาประมาณ 1 ชั่วโมงในการแก้ไข
                หากปัญหาได้รับการแก้ไขแล้วจะแจ้งให้ทราบทันทีค่ะ
              </p>
            </div>
          </div>
        </div>
      ) : (
        <>
          {children}
          <GlobalLoader />
        </>
      )}
    </>
  );
}
